<template>
  <v-app>
    <HeaderTemplate />
    <MenuTemplate />
    <v-main class="cor-fundo">
      <v-container style="height: 100% !important" class="mb-3" fluid>
        <snack-erro />

        <v-layout align-center fill-height justify-center v-if="loadingApp">
          <v-progress-circular size="55" width="2" indeterminate></v-progress-circular>
        </v-layout>

        <router-view v-if="!loadingApp" />
        
      </v-container>
    </v-main>
    <FooterTemplate />
  </v-app>
</template>

<script>
import HeaderTemplate from "./template/Header.vue";
import MenuTemplate from "./template/Menu.vue";
import FooterTemplate from "./template/Footer.vue";
import SnackErro from "./components/tela/SnackErro.vue";
import { mapState } from "vuex";

export default {
  components: {
    HeaderTemplate,
    MenuTemplate,
    FooterTemplate,
    SnackErro,
  },
  name: "App",
  computed: {
    ...mapState("pedidos", ["syncPedidos"]),
    ...mapState("sistema", ["loadingApp"]),
  },
  data: () => ({
    // Variáveis locais limpas
  }),
  methods: {
    isMobile() {
      return this.$mq ? this.$mq === "sm" : false;
    },
  },
  // --- A MÁGICA ACONTECE AQUI ---
  async mounted() {
    // 1. O Banco já foi iniciado pelo main.js (garantido)
    console.log("App montado. Banco pronto.");

    // 2. Verifica internet e dispara a sincronização em SEGUNDO PLANO
    if (navigator.onLine) {
       console.log("Online detectado: Iniciando sincronização de pedidos...");
       // Dispara a ação sem 'await' para não travar a tela
       this.$store.dispatch('pedidos/sincronizarPedidos').catch(err => {
          console.error("Erro na sincronização automática:", err);
       });
    }
  },
};
</script>

<style>
* {
  text-transform: none;
  font-family: "Poppins" !important;
  word-break: normal !important;
}

.cor-fundo {
  background-color: #e6e6e6 !important;
}

.toasted {
  font-size: 1.1rem !important;
}
</style>